import { PageComponent } from '@root/pages/Type';

import classNames from 'classnames';
import Icon from '@root/components/Icon';

type OsIconProps = {
    name?: string;
    className?: string;
    active?: boolean;
};

const OsIcon: PageComponent<OsIconProps> = ({
    name,
    className,
    active = false,
}) => {
    let iconSrc = '/static/img/icons/os/linux.svg';
    if (typeof name === 'undefined') {
        name = 'linux';
    }
    let lowName = name?.toLowerCase();
    switch (lowName) {
        case 'kvm':
        case 'idrac':
            iconSrc = `/static/img/icons/os/iso${active ? '-active' : ''}.svg`;
            break;
        default:
            iconSrc = `/static/img/icons/os/${lowName}${
                active ? '-active' : ''
            }.svg`;
    }
    return <Icon src={iconSrc} className={classNames(className)} />;
};

export default OsIcon;
